import { EMPTY_CHARGE_DATA_SEARCH_MODEL } from 'presentation/model/ChargeDataEnquiry/ChargeDataSearchModel';
import { useState } from 'react';
import {createContainer} from "react-tracked";

const {
    Provider: ChargeDataSearchProvider,
    useTracked: useChargeDataSearchTracked
} = createContainer(() => useState(EMPTY_CHARGE_DATA_SEARCH_MODEL), {concurrentMode: true});
export {ChargeDataSearchProvider, useChargeDataSearchTracked};